module.exports = __webpack_public_path__ + "static/media/spinner.8f400896.gif";